import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { adjustDateFormatAsPerPCalendar, CrudService, CrudType, currentComponentPageBasedPermissionsSelector$, CustomDirectiveConfig, datePipeConversion, getPDropdownData, IApplicationResponse, ModulesBasedApiSuffix, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, SERVER_REQUEST_DATE_TRANSFORM, setRequiredValidator, SnackbarService, UserService } from '@app/shared';
import { PrimengDeleteConfirmDialogComponent } from '@app/shared/components/primeng-delete-confirm-dialog/primeng-delete-confirm-dialog.component';
import { DEALER_COMPONENT, DealerBillingInfoModalComponent, DealerBranchCategoryDetailModelNew, DealerModuleApiSuffixModels } from '@modules/dealer';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { UserLogin } from '@modules/others/models/others-module-models';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { AverageContractAddEditComponent } from '../../average-contract-config/average-contract-add-edit.component';
@Component({
  selector: 'app-dealer-branch-category-add-edit',
  templateUrl: './dealer-branch-category-add-edit.component.html',
  styles: [`
  ::ng-deep #dealer-branch  .ui-inputtext{
    border:none !important;
  }
  .disabled-btn{
    pointer-events:none
  }`
  ]
})
export class DealerBranchCategoryAddEditComponent extends PrimeNgTableVariablesModel implements OnInit {

  dealerBranchCategoryAddEditForm: FormGroup;
  dealerCategoryList: any = [];
  dealerBranchList: any = [];
  dealerBranchCategoryId: any;
  viewable: boolean;
  userData: UserLogin;
  primengTableConfigPropertiesForBonus: any;
  selectedTabIndex: any = 0;
  eventSubscription: any;
  btnName: string;
  showAction: boolean;
  dealerId: string;
  dealerTypeId: string;
  referenceId: string;
  dealerBranchCategoryDetail: any;
  dropdownSubscription: any;
  isSubmitted: boolean;
  isAnAlphaNumericOnly = new CustomDirectiveConfig({ isAnAlphaNumericOnly: true });
  isADecimalMaxTwoDigitsTwoDecimals = new CustomDirectiveConfig({ isADecimalMaxTwoDigitsTwoDecimals: true, shouldPasteKeyboardEventBeRestricted: true });
  primengTableConfigPropertiesPageLevelAccess: any = {
    tableComponentConfigs: {
      tabsList: [
        {}, {}, {}, {}, {}
      ]
    }
  }

  isCategoryErrorExists = false;
  dataList: any;
  dateFormat = adjustDateFormatAsPerPCalendar();
  dealerBranchId = ""
  bonusMultipleSchemeList: any = [];
  isShowNoRecord = false;
  techAreaList: any = [];
  isSAPValidation: boolean = false;
  isANumberZeroToNinetyNine = new CustomDirectiveConfig({ isANumberZeroToNinetyNine: true, shouldPasteKeyboardEventBeRestricted: true });

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private store: Store<AppState>, private snackbarService: SnackbarService,
    private formBuilder: FormBuilder, private rxjsService: RxjsService, private crudService: CrudService, private dialogService: DialogService,
    private userService: UserService) {
    super();
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.dealerId = (Object.keys(params['params']).length > 0) ? params['params']['dealerId'] : '';
      this.dealerBranchId = (Object.keys(params['params']).length > 0) ? params['params']['dealerBranchId'] : '';
      this.dealerTypeId = (Object.keys(params['params']).length > 0) ? params['params']['dealerTypeId'] : '';
      this.referenceId = (Object.keys(params['params']).length > 0) ? params['params']['referenceId'] : '';
    });

    this.primengTableConfigProperties = {
      tableCaption: 'Update Dealer Branch Category',
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Dealer Management', relativeRouterUrl: '' }, { displayName: 'Dealer Maintenance', relativeRouterUrl: '/dealer/dealer-maintenance' }, { displayName: 'Dealer Branch Category', relativeRouterUrl: '/dealer/dealer-maintenance', queryParams: { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, } }, { displayName: 'View', relativeRouterUrl: '/dealer/dealer-maintenance/branch-category/view', queryParams: { tab: 3, dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, dealerBranchId: this.dealerBranchId, } }, { displayName: 'Update Dealer Branch Category', relativeRouterUrl: '', }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: 'Update Dealer Branch Category',
            dataKey: 'dealerBranchCategoryCommissionConfigId',
            enableAction: true,
            enableScrollable: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [
              { field: 'dealerCategoryTypeName', header: 'Client Category', width: '150px' },
              { field: 'clientDescription', header: 'Description', width: '150px' },
              { field: 'purchaseMultiples', header: 'Purchase Multiplies', width: '180px' },
              { field: 'dsfValue', header: 'DSF Allocations', width: '150px' },
              { field: 'commissionPercentage', header: 'Recurring Commission', width: '180px' },
              { field: 'financialWarrantyMonths', header: 'Financial Warrenty', width: '180px' },
              { field: 'technicalWarrantyMonths', header: 'Technical Warrenty', width: '180px' },
              { field: 'effectiveFrom', header: 'Effective Date', width: '180px', isDate: true },
              { field: 'approvalStatus', header: 'Approval Status', width: '180px' },
            ],
            enableBreadCrumb: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER_NEW_BILLING_INFO,
            moduleName: ModulesBasedApiSuffix.DEALER,
          },

          {
            caption: 'Bonus Multiple Scheme',
            dataKey: 'dealerBranchAverageContractConfigId',
            enableAction: true,
            enableScrollable: true,
            enableHyperLink: false,
            cursorLinkIndex: 0,
            columns: [
              // { field: 'levels', header: 'Level', width: '150px' },
              { field: 'contractFrom', header: 'Contract From', width: '150px' },
              { field: 'contractTo', header: 'Contract To', width: '180px' },
              { field: 'bonus', header: 'Bonus', width: '150px' },
              { field: 'status', header: 'Action', width: '200px', isUpdateDelete: true },
            ],
            enableBreadCrumb: true,
            apiSuffixModel: DealerModuleApiSuffixModels.DEALER,
            deleteAPISuffixModel: DealerModuleApiSuffixModels.DEALER_BONUS_SCHEME_INFO,
            moduleName: ModulesBasedApiSuffix.DEALER,

          },
        ]
      }
    }


    this.rxjsService.setGlobalLoaderProperty(false);
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    });
    if (this.referenceId) {
      this.primengTableConfigProperties.breadCrumbItems[2].queryParams = { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, referenceId: this.referenceId };
      this.primengTableConfigProperties.breadCrumbItems[3].queryParams = { dealerId: this.dealerId, dealerTypeId: this.dealerTypeId, dealerBranchId: this.dealerBranchId, referenceId: this.referenceId };
    }
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData()
    this.onLoadValue();
    this.getBillingInfoList('effective');
    this.getBonusSchemeList();
    this.getTechAreaList();
  }
  dealerTypeList = [];
  isDealerTypeIdIsI = false;

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      let permission = response[0][DEALER_COMPONENT.DEALER_MAINTENANCE]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigPropertiesPageLevelAccess, permission);
        this.primengTableConfigPropertiesPageLevelAccess = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  onLoadValue() {
    this.initForm();
  }

  getDealerDetails() {
    this.crudService.get(
      ModulesBasedApiSuffix.DEALER,
      DealerModuleApiSuffixModels.DEALER,
      this.dealerId,
      false, null
    ).subscribe(data => {
      if (data.isSuccess && data.statusCode == 200) {
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].enableAction = true;
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].enableViewBtn = true;
      }
    });
  }

  initForm(dealerBranchCategoryDetailModel?: DealerBranchCategoryDetailModelNew) {
    let dealerBranchCategoryModel = new DealerBranchCategoryDetailModelNew(dealerBranchCategoryDetailModel);
    this.dealerBranchCategoryAddEditForm = this.formBuilder.group({});
    Object.keys(dealerBranchCategoryModel).forEach((key) => {
      if (typeof dealerBranchCategoryModel[key] === 'object') {
        this.dealerBranchCategoryAddEditForm.addControl(key, new FormArray(dealerBranchCategoryModel[key]));
      } else if (!this.viewable) {
        this.dealerBranchCategoryAddEditForm.addControl(key, new FormControl(dealerBranchCategoryModel[key]));
      }
    });
    // Remove required validators for optional fields if they exist
    if (this.dealerBranchCategoryAddEditForm.get('attritionThresholdRate')) {
      this.dealerBranchCategoryAddEditForm.get('attritionThresholdRate').clearValidators();
      this.dealerBranchCategoryAddEditForm.get('attritionThresholdRate').updateValueAndValidity();
    }
    if (this.dealerBranchCategoryAddEditForm.get('dealerCategoryTypeId')) {
      this.dealerBranchCategoryAddEditForm.get('dealerCategoryTypeId').clearValidators();
      this.dealerBranchCategoryAddEditForm.get('dealerCategoryTypeId').updateValueAndValidity();
    }
    this.onFormControlValueChanges();
    this.dealerBranchCategoryAddEditForm.get('pricingStatus').setValue('effective');
    this.onLoadDealerCategory();
    this.getBasicFormData();
  }

  onFormControlValueChanges() {
    this.dealerBranchCategoryAddEditForm.get('pricingStatus').valueChanges.subscribe(res => {
      if (res == 'current') {
        this.getBillingInfoList('current');
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns = this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns.filter(col => col.field != 'status');

      }
      else if (res == 'effective') {
        this.getBillingInfoList('effective');
        this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns.push({ field: 'status', header: 'Action', width: '200px', isUpdateDelete: true });
      }
    })
    this.dealerBranchCategoryAddEditForm
      .get("techAreaId")
      .valueChanges.subscribe((id: string) => {
        if (id) {
          this.onChangeTechArea(id);
        }
      });

    this.dealerBranchCategoryAddEditForm
      .get("isQualifyBonus")
      .valueChanges.subscribe((data: boolean) => {
        if (data) {
          this.dealerBranchCategoryAddEditForm
            .get("eligiblePeriodInMonth").enable();
        } else {
          this.dealerBranchCategoryAddEditForm.get("eligiblePeriodInMonth").disable();
        }
      });
  }
  onChangeTechArea(techId) {
    if (techId) {
      this.onLoadTechAreaDetails(techId);
    }
  }

  onLoadTechAreaDetails(techId) {
    if (techId && techId != 'Null') {
      this.rxjsService.setGlobalLoaderProperty(true);
      this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN,
        DealerModuleApiSuffixModels.DEALER_TECH_AREA_DETAILS,
        undefined,
        false, prepareRequiredHttpParams({ techAreaId: techId })
      ).subscribe(data => {
        if (data.isSuccess && data.statusCode == 200 && data.resources) {
          let techResult = data.resources;
          this.dealerBranchCategoryAddEditForm.get('warehouseName').setValue(techResult.warehouseName);
          this.dealerBranchCategoryAddEditForm.get('storageLocationName').setValue(techResult.storageLocationName);
          this.dealerBranchCategoryAddEditForm.get('warehouseId').setValue(techResult.warehouseId);
          this.dealerBranchCategoryAddEditForm.get('locationId').setValue(techResult.storageLocationId);
        }
      });
      this.rxjsService.setGlobalLoaderProperty(false);
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }
  onCRUDRequested(type: CrudType | string, row?: object, unknownVar?: number | string): void {
    switch (type) {
      case CrudType.EDIT:
        this.onEditButtonClicked(row);
        break;
      case CrudType.VIEW:
        this.onEditButtonClicked(row);
        break;
      case CrudType.DELETE:
        this.onDeleteButtonClicked(row, 'billingInfo');
        break;
    }
  }

  onEditButtonClicked(row: any): void {
    this.onCreateNewPrice(row);
  }

  onDeleteButtonClicked(row: any, type: string): void {
    if (type == 'billingInfo') {
      this.selectedTabIndex = 0;
    } else {
      this.selectedTabIndex = 1;
    }
    var deletableIds = row[this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].dataKey];
    const ref = this.dialogService.open(PrimengDeleteConfirmDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,
      width: '400px',
      data: {
        selectAll: (this.totalRecords == this.selectedRows.length) ? true : false,
        moduleName: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
        apiSuffixModel: this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].deleteAPISuffixModel,
        method: 'delete',
        dataObject: {
          ids: this.selectedRows.length > 0 ? deletableIds.join(',') : deletableIds,
          isDeleted: true,
          modifiedUserId: this.userData?.userId,
        }
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.selectedRows = [];
        if (type == 'billingInfo') {
          this.getBillingInfoList(this.dealerBranchCategoryAddEditForm.get('pricingStatus').value);
        } else {
          this.getBonusSchemeList();
        }
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  getBasicFormData() {
    let api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_INFO,
      null, false, prepareRequiredHttpParams({ dealerId: this.dealerId, dealerBranchId: this.dealerBranchId }));
    if (this.referenceId) {
      api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_INFO,
        null, false, prepareRequiredHttpParams({
          dealerId: this.dealerId, dealerBranchId: this.dealerBranchId,
          referenceId: this.referenceId, userId: this.userData?.userId
        }));
    }
    api.subscribe((response) => {
      this.editValue(response);
    });
  }

  editValue(response) {
    if (response?.isSuccess && response?.statusCode == 200) {
      this.dealerBranchCategoryDetail = response?.resources;
      if (response?.resources?.dealerBranchCode) {
        this.dealerBranchCategoryAddEditForm.get('dealerBranchCode').setValue(response?.resources?.dealerBranchCode);
      }
      if (response?.resources?.branchName) {
        this.dealerBranchCategoryAddEditForm.get('branchName').setValue(response?.resources?.branchName);
      }
      if (response?.resources?.dealerCategoryTypeId && response?.resources?.dealerCategoryTypeId.length > 0) {
        this.dealerBranchCategoryAddEditForm.get('dealerCategoryTypeId').setValue(response?.resources?.dealerCategoryTypeId);
      }
      if (response?.resources?.bonusMultipleStartDate) {
        response.resources.bonusMultipleStartDate = response?.resources?.bonusMultipleStartDate ? new Date(response?.resources?.bonusMultipleStartDate) : null;
      }
      if (response?.resources?.commissionStartDate) {
        response.resources.commissionStartDate = response?.resources?.commissionStartDate ? new Date(response?.resources?.commissionStartDate) : null;
      }
      this.isSAPValidation = (response?.resources?.isAllowEdit && this.referenceId) ? true : false;
      // Set required validators for mandatory fields
      if (this.isSAPValidation) {
        this.dealerBranchCategoryAddEditForm = setRequiredValidator(this.dealerBranchCategoryAddEditForm, ["sapVendorNoCatA", "sapVendorNoCatC"]);
      }
      this.dealerBranchCategoryAddEditForm.get('isQualifyBonus').setValue(response?.resources?.isQualifyBonus);
      this.dealerBranchCategoryAddEditForm.get('eligiblePeriodInMonth').setValue(response?.resources?.eligiblePeriodInMonth);
      this.dealerBranchCategoryAddEditForm.patchValue(response?.resources);
    }
  }

  onLoadDealerCategory(res?: any, dropdown = true) {
    this.crudService.dropdown(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.UX_DEALER_BRANCH_CATEGORY_COMMISSION_TYPE)
      .subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          this.dealerCategoryList = getPDropdownData(response?.resources);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  onSubmit() {
    this.dealerBranchCategoryAddEditForm.markAsUntouched();
    if (this.dealerBranchCategoryAddEditForm.invalid) {
      this.dealerBranchCategoryAddEditForm.markAllAsTouched();
      return;
    }
    if (this.isCategoryErrorExists == true) {
      return this.snackbarService.openSnackbar("Please try selecting any other Monthly Commission Type", ResponseMessageTypes.WARNING);
    }
    if (!this.viewable) {
      this.onAfterSubmit();
    }
  }

  onAfterSubmit() {
    this.rxjsService.setGlobalLoaderProperty(true);
    const dealerBranchCategoryObj = {
      dealerId: this.dealerId,
      dealerBranchId: this.dealerBranchId,
      modifieduserId: this.userData?.userId,
      ...this.dealerBranchCategoryAddEditForm.getRawValue()
    }

    dealerBranchCategoryObj['dealerCategoryTypeId'] = this.dealerBranchCategoryAddEditForm.value.dealerCategoryTypeId ? this.dealerBranchCategoryAddEditForm.value.dealerCategoryTypeId.toString() : null;
    if (this.dealerBranchCategoryId) {
      dealerBranchCategoryObj['dealerBranchCategoryId'] = this.dealerBranchCategoryId;
    }
    let api = this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_INFO, dealerBranchCategoryObj);
    if (this.dealerBranchCategoryId) {
      api = this.crudService.update(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BRANCH_CATEGORY_API, dealerBranchCategoryObj)
    }
    this.isSubmitted = true;
    api.subscribe((response: IApplicationResponse) => {
      if (response?.isSuccess && response?.statusCode == 200) {
        this.onCancelClick();
      }
      this.isSubmitted = false;
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCancelClick() {
    if (this.referenceId) {
      this.router.navigate(['/dealer/dealer-maintenance'], { queryParams: { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, referenceId: this.referenceId, }, skipLocationChange: false })
    } else {
      this.router.navigate(['/dealer/dealer-maintenance'], { queryParams: { tab: 3, id: this.dealerId, dealerTypeId: this.dealerTypeId, } })
    }
  }

  onCreateNewPrice(data?: any) {
    const dialogRef = this.dialogService.open(DealerBillingInfoModalComponent, {
      header: 'Create New Billing Info',
      width: '60%',
      closable: true,
      showHeader: false,
      data: data ? data : {}
    });
    dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.postNewBillingInfo(result)
      }
    });
  }

  postNewBillingInfo(postData) {
    requestAnimationFrame(() => {
      this.rxjsService.setGlobalLoaderProperty(true);
    });
    postData['createdUserId'] = this.userData?.userId;
    postData['modifiedUserId'] = this.userData?.userId;
    postData['dealerBranchCategoryCommissionConfigId'] = postData?.dealerBranchCategoryCommissionConfigId ? postData?.dealerBranchCategoryCommissionConfigId : null;
    postData['dealerId'] = postData?.dealerId ? postData?.dealerId : this.dealerId;
    postData['dealerBranchId'] = postData?.dealerBranchId ? postData?.dealerBranchId : this.dealerBranchId;
    postData['effectiveFrom'] = postData?.effectiveFrom ? datePipeConversion(postData['effectiveFrom'], SERVER_REQUEST_DATE_TRANSFORM) : null;
    delete postData.createdUserId;
    let api = this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_NEW_BILLING_INFO, postData);
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.getBillingInfoList(this.dealerBranchCategoryAddEditForm.get('pricingStatus').value);
      }
      else {
        this.rxjsService.setGlobalLoaderProperty(false);
      }
    });
  }

  getBillingInfoList(infoType: string) {
    let api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_NEW_BILLING_INFO, null, null, prepareRequiredHttpParams({ dealerId: this.dealerId, dealerBranchId: this.dealerBranchId, infoType: infoType }));
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.rxjsService.setGlobalLoaderProperty(false);
        this.dataList = response.resources;
        this.totalRecords = this.dataList.length;
      }
    });
  }

  getBonusSchemeList() {
    let api = this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BONUS_SCHEME_INFO, null, null, prepareRequiredHttpParams({ dealerId: this.dealerId, dealerBranchId: this.dealerBranchId }));
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.rxjsService.setGlobalLoaderProperty(false);
        console.log('Bonus Scheme List', response.resources)
        this.bonusMultipleSchemeList = response.resources;
      }
    })
  }

  openBonusSchemePopup(header, row?, screen?) {
    const rowData = { ...row };
    const ref = this.dialogService.open(AverageContractAddEditComponent, {
      header: header,
      baseZIndex: 1000,
      width: '650px',
      closable: false,
      showHeader: false,
      data: {
        createdUserId: this.userData?.userId ? this.userData?.userId : null,
        row: rowData,
        screen: screen
      },
    });
    this.userService.openedPrimeDialog.push(ref);
    ref.onClose.subscribe((result) => {
      if (result) {
        this.postBonusSchemeData(result)
      }
      this.userService.openedPrimeDialog = [];
    });
  }

  postBonusSchemeData(postData) {
    requestAnimationFrame(() => {
      this.rxjsService.setGlobalLoaderProperty(true);
    });
    postData['dealerId'] = postData?.dealerId ? postData?.dealerId : this.dealerId;
    postData['dealerBranchId'] = postData?.dealerBranchId ? postData?.dealerBranchId : this.dealerBranchId;
    postData['modifiedUserId'] = this.userData?.userId;
    postData['levels'] = postData?.levels ? postData?.levels : this.bonusMultipleSchemeList?.length + 1;
    postData['bonus'] = + postData?.bonusMultiple;
    postData['dealerBranchAverageContractConfigId'] = postData?.dealerBranchAverageContractConfigId ? postData?.dealerBranchAverageContractConfigId : null;
    delete postData.bonusMultiple;
    let api = this.crudService.create(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_BONUS_SCHEME_INFO, postData);
    api.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.getBonusSchemeList();
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    })
  }

  onActionSubmitedForBonusScheme(event) {
    onActionSubmittedUtil(event, this.onCRUDRequestedForBonusScheme.bind(this));
  }
  onCRUDRequestedForBonusScheme(type: CrudType | string, row?: object, unknownVar?: number | string): void {
    switch (type) {
      case CrudType.EDIT:
        this.openBonusSchemePopup('Edit Bonus Multiple Scheme', row, 'edit');
        break;
      case CrudType.VIEW:
        this.openBonusSchemePopup('Edit Bonus Multiple Scheme', row, 'edit');
        break;
      case CrudType.DELETE:
        this.onDeleteButtonClicked(row, 'bonusScheme');
        break;
    }
  }

  getTechAreaList() {
    const params = { isDealer: true, isDescription: true }
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.UX_AREAS,
      undefined,
      false, prepareRequiredHttpParams(params)
    ).subscribe(data => {
      if (data.isSuccess && data.statusCode == 200) {
        this.techAreaList = data.resources;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  ngOnDestroy() {
    if (this.dropdownSubscription) {
      this.dropdownSubscription.unsubscribe();
    }
    if (this.eventSubscription) {
      this.eventSubscription?.unsubscribe();
    }
  }
}
